import { Story, Meta } from '@storybook/web-components';
import { html } from 'lit-html';
import './json-viewer';

export default {
  title: '@gsmlg/json-viewer',
  argTypes: {},
} as Meta;

export interface JsonViewer {
  textContent: string;
  inline: boolean;
  indent: number;
}

const Template: Story<JsonViewer> = ({ textContent, inline, indent }) => html`
  <json-viewer ?inline=${inline} indent=${indent}>${textContent}</json-viewer>
`;

export const Basic = Template.bind({});

Basic.args = {
  textContent: '{"name": "JSON Viewer"}',
  inline: false,
  indent: 4,
};
